module.exports = __webpack_public_path__ + "static/activation-236e1642413e21418757d1a2a0642f17.webp";